module.exports = __webpack_public_path__ + "img/icon-metadata.a8e4ee62.svg";